import { isPast, parseISO } from "date-fns";
import { Icon, Panel, Typography } from "@/components/atoms";
import { DriverNavigation } from "../../../common/DriverNavigation";
import { useProfileContext } from "../context";
import { Documents } from "./fields/Documents";
import { AccountDetails } from "./sections/AccountDetails";
import { CustomApplicationAnswers } from "./sections/CustomApplicationAnswers";
import { DriverDetails } from "./sections/DriverDetails";
import { DriverHeader } from "./sections/DriverHeader";
import { DriverStatus } from "./sections/DriverStatus";
import { EmergencyContact } from "./sections/EmergencyContact";

const LicenceExpiredBanner = () => {
  const { driver } = useProfileContext();
  const expiryDate = driver.licence?.expiry;

  if (!expiryDate || !isPast(parseISO(expiryDate))) return null;

  return (
    <div className="mt-4 flex flex-col gap-1 rounded-lg border border-danger bg-danger/10 py-3 px-4">
      <Typography variant="title" className="flex gap-2 text-danger">
        Driver&apos;s License Expired
        <Icon name="InfoCircle" variant="Bold" size="md" className="text-danger" />
      </Typography>
      <Typography variant="paragraph" className="text-danger">
        This driver needs to upload an updated license in the mobile app to stay active.
      </Typography>
    </div>
  );
};

export const ApprovedDriverPanel = () => {
  const { driver } = useProfileContext();

  return (
    <div className="flex gap-3">
      <DriverNavigation driver={driver} />
      <Panel>
        <DriverHeader />
        <LicenceExpiredBanner />
        <DriverStatus />
        <AccountDetails />
        <DriverDetails />
        <CustomApplicationAnswers />
        <Documents />
        <EmergencyContact />
      </Panel>
    </div>
  );
};
